<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <div>
          <b-form autocomplete="off" ref="aud">
            <FloatingLabel
              :value="details.username ? details.username : details.user_id"
              label="User"
              :to="`/users/${details.user_id}`"
              type="link"
              size="sm"
            />

            <b-row>
              <b-col cols="12" md="4">
                <FloatingLabel :value="details.app_id" label="App Id" type="plain" size="sm"/>
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel :value="details.timestamp" label="Timestamp" type="plain" size="sm"/>
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel :value="details.ip" label="IP" type="plain" size="sm"/>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="6">
                <FloatingLabel
                  :value="details.action_type"
                  label="Action Type"
                  type="plain"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="6">
                <FloatingLabel :value="details.action" label="Action" type="plain" size="sm"/>
              </b-col>
            </b-row>

            <FloatingLabel
              v-model="details.action_params"
              label="Action Params"
              autocomplete="false"
              type="textarea"
              size="sm"
              :readonly="true"
            />

            <FloatingLabel
              v-model="details.result"
              label="Result"
              autocomplete="false"
              type="textarea"
              size="sm"
              :readonly="true"
            />

            <div v-if="details.action == 'LotoEventClearResult'">
              <b-form-group :label="$t('Affected Data')" class="grouping py-2 px-3 mb-3 mt-0">
                <LotoEventClearResult :json="details.affected_data"/>
              </b-form-group>
            </div>
            <div v-else>
              <FloatingLabel
                v-model="details.affected_data"
                label="Affected Data"
                autocomplete="false"
                type="textarea"
                size="sm"
                :readonly="true"
              />
            </div>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import { errorConf } from "@/shared/notifications";
import FloatingLabel from "@/components/FloatingLabel";
import LotoEventClearResult from "./formats/LotoEventClearResult";

export default {
  name: "audit",
  props: ["selectedeid"],
  components: {
    FloatingLabel,
    LotoEventClearResult
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    if (this.eid != "0" && this.eid != "") {
      this.loadData();
    } else {
      this.$router.push("/audits");
    }
  },
  data: function() {
    return {
      eid: "",
      details: {
        user_id: "", //	integer NULL	User which generated the action (NULL for guests)
        app_id: "", //	text	Application which generated the action (backoffice or an app ID)
        timestamp: "", //	bigint	Action timestamp
        ip: "", //	text	Originating IP
        action_type: "", //	text	Action category
        action: "", // text	Action/method name
        action_params: "", //	text NULL	Action parameters
        result: "", //	text
        affected_data: "",
        username: ""
      }
    };
  },
  methods: {
    loadData() {
      if (this.eid == "") return;

      const loadDet = this.$loading.open({
        container: this.$refs.aud
      });

      this.$store
        .dispatch("audit/read", this.eid)
        .then(resp => {
          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";

      this.details.user_id = r.euser_id;
      this.details.username = r.username ? r.username : "";
      this.details.app_id = r.app_id;
      this.details.timestamp = this.mom_unix(r.timestamp).format(
        "DD-MM-YY, HH:mm:ss"
      );
      this.details.ip = r.ip;
      this.details.action_type = r.action_type;
      this.details.action = r.action;
      try {
        this.details.action_params = JSON.stringify(
          JSON.parse(r.action_params),
          null,
          4
        );
      } catch (err) {
        // noop
      }
      try {
        this.details.result = JSON.stringify(JSON.parse(r.result), null, 2);
      } catch (err) {
        this.details.result = r.result;
      }

      try {
        this.details.affected_data = JSON.stringify(
          JSON.parse(r.affected_data),
          null,
          2
        );
      } catch (err) {
        this.details.affected_data = r.affected_data;
      }
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    mom_unix(val) {
      return moment.unix(val / 1e9);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
